export default "__VITE_ASSET__a31d1a30__"